/**
 * Shared viewport reads + subscriptions (resize, orientation, visualViewport, orientation MQL).
 */

export function readViewportCssDimensions(): { width: number; height: number } {
  if (typeof window === 'undefined') return { width: 0, height: 0 }
  return {
    width: window.innerWidth,
    height: window.innerHeight
  }
}

export function readViewportIsPortrait(): boolean {
  if (typeof window === 'undefined') return false
  if (typeof window.matchMedia === 'function') {
    return window.matchMedia('(orientation: portrait)').matches
  }
  const { width, height } = readViewportCssDimensions()
  return height > width
}

export function subscribeViewportChange(handler: () => void): () => void {
  if (typeof window === 'undefined') return () => {}

  window.addEventListener('resize', handler)
  window.addEventListener('orientationchange', handler)

  const vv = window.visualViewport
  if (vv) {
    vv.addEventListener('resize', handler)
    vv.addEventListener('scroll', handler)
  }

  const mql = typeof window.matchMedia === 'function' ? window.matchMedia('(orientation: portrait)') : null
  if (mql) {
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handler)
    } else {
      (mql as MediaQueryList & { addListener: (cb: () => void) => void }).addListener(handler)
    }
  }

  return (): void => {
    window.removeEventListener('resize', handler)
    window.removeEventListener('orientationchange', handler)
    if (vv) {
      vv.removeEventListener('resize', handler)
      vv.removeEventListener('scroll', handler)
    }
    if (mql) {
      if (typeof mql.removeEventListener === 'function') {
        mql.removeEventListener('change', handler)
      } else {
        (mql as MediaQueryList & { removeListener: (cb: () => void) => void }).removeListener(handler)
      }
    }
  }
}
